<template>
  <div>
    <div class="rf-cabecera">
      <span class="rf-eyebrow">Conoce</span>
      <h1 class="rf-titulo-sans">{{ servicios ? 'Nuestros Servicios' : 'Quiénes Somos' }}</h1>
    </div>
    <div class="rf-texto">
      <p v-for="(parrafo, i) in parrafos" :key="i">{{ parrafo }}</p>
      <ul v-if="servicios && sitio.servicios.length" class="rf-servicios">
        <li v-for="s in sitio.servicios" :key="s">{{ s }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RfTexto',
  props: {
    // 'servicios' o 'quienes-somos'.
    tipo: { type: String, required: true },
    sitio: { type: Object, required: true },
  },
  computed: {
    servicios() {
      return this.tipo === 'servicios';
    },
    parrafos() {
      const texto = this.servicios ? this.sitio.servicios_texto : this.sitio.quienes_somos_texto;
      return (texto || '').split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
    },
  },
};
</script>
